export default __webpack_public_path__ + "static/media/FinanceForEng.8578d2b5.mrt";